import React from "react";
import {
  ErrorWithMessage,
  LocationDataFields,
  LocationsGetResponse,
  ReduxFreeformActions,
  ReduxStoreRoot,
  TerminalsGetResponse,
} from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { fetchFunction, getErrorDictionary } from "../../util";
import { setTerminals, setTerminalsCache } from "./Terminals.state";
import {
  Box,
  ButtonWithLink,
  Cluster,
  FormSelect,
  FormSelectOption,
} from "@thecb/components";
import { useClearFieldOnUnmount } from "../../hooks";
import { getDefaultFormSelectOption } from "../../util/form-select";

interface Props {
  actions: {
    forms: {
      terminalsTableForm: {
        actions: ReduxFreeformActions;
      };
    };
  };
}

const TerminalsTableControls = ({
  actions: {
    forms: {
      terminalsTableForm: { actions },
    },
  },
}: Props) => {
  const dispatch = useDispatch();
  const { posApiEndpoint } = useSelector((state: ReduxStoreRoot) => state.config);
  const { terminalsTableForm } = useSelector(
    (state: ReduxStoreRoot) => state.posConfigTool.terminals.forms
  );
  const {
    client: {
      value: { brand: selectedBrand },
    },
  } = useSelector((state: ReduxStoreRoot) => state.currentUser);
  const { data: locationsGETResponse } = useQuery<
    LocationsGetResponse,
    ErrorWithMessage
  >({
    queryKey: [`GET -> /locations?brand=${selectedBrand}`],
    queryFn: () =>
      fetchFunction(`${posApiEndpoint}/locations?brand=${selectedBrand}`),
  });

  const baseTerminalsQuery = `${posApiEndpoint}/terminals?brand=${selectedBrand}`;
  const terminalsQuery = terminalsTableForm.location_id.rawValue
    ? `${baseTerminalsQuery}&location_id=${terminalsTableForm.location_id.rawValue}`
    : baseTerminalsQuery;
  useQuery<TerminalsGetResponse, ErrorWithMessage>({
    queryKey: [terminalsQuery],
    queryFn: () => fetchFunction(terminalsQuery),
    onSuccess: (res: TerminalsGetResponse) => {
      dispatch(setTerminals(res.data));
      dispatch(setTerminalsCache(res.data));
    },
  });

  const locations: FormSelectOption[] =
    locationsGETResponse?.data?.map((location: LocationDataFields) => ({
      text: location.name,
      value: String(location.id),
    })) ?? [];

  useClearFieldOnUnmount(actions.fields.location_id);

  return (
    <Box padding="0 0 0.5rem">
      <Cluster align="center" childGap="1rem" extraStyles={`overflow: visible;`}>
        <Box padding="0">
          <FormSelect
            labelTextWhenNoError="Location"
            errorMessages={getErrorDictionary("Location")}
            options={[getDefaultFormSelectOption("Locations"), ...locations]}
            field={terminalsTableForm.location_id}
            fieldActions={actions.fields.location_id}
          />
        </Box>
        <Box padding="0">
          <ButtonWithLink
            variant="primary"
            url={`/pos-config/terminals/create`}
            text="Create New Terminal"
            extraStyles={`
              border-radius: 19px;
              margin: 0;
            `}
          />
        </Box>
      </Cluster>
    </Box>
  );
};

export default TerminalsTableControls;
